import axios from 'axios';

export const backendApiService = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});
